interface Image {
  name: string;
  image: string;
}

export const findImageByName = (items: Image[], targetName: string): string => {
  for (const item of items) {
    if (item.name === targetName) {
      return item.image;
    }
  }
  console.warn('Missing icon: ', targetName);
  return '';
};
